import { APP_VERSION } from '../version';

/**
 * Vergleicht die Build-Version des Clients (compile-time-konstant aus
 * version.ts) mit der Version, die der Server via /api/v1/health
 * meldet. Bei Mismatch wird der Service Worker entregistriert und
 * die Caches gelöscht, dann reload — so kommt der User garantiert auf
 * die aktuelle Frontend-Version, auch wenn Workbox seinen Job nicht macht.
 */
export async function checkVersionAndReloadIfStale(): Promise<void> {
  try {
    const res = await fetch('/api/v1/health', { cache: 'no-store' });
    if (!res.ok) return;
    const data = (await res.json()) as { version?: string };
    const serverVersion = data.version;
    if (!serverVersion) return;
    if (serverVersion === APP_VERSION) return;

    console.warn(
      `[stromo] Frontend ${APP_VERSION} != Server ${serverVersion} — räume Cache und reloade`,
    );
    await purgeAndReload();
  } catch {
    // Offline oder Server nicht erreichbar — ignorieren, der User wird's
    // selbst merken
  }
}

async function purgeAndReload(): Promise<void> {
  // Service Worker entregistrieren
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  }
  // Alle Caches leeren
  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.map((n) => caches.delete(n)));
  }
  // Verhindere Reload-Loop: einen Marker in sessionStorage, der nach
  // dem zweiten Reload erlaubt anzunehmen "neue Version ist jetzt aktiv"
  const flag = sessionStorage.getItem('stromo:reloaded-for-version');
  if (!flag) {
    sessionStorage.setItem('stromo:reloaded-for-version', '1');
    window.location.reload();
  }
}
